/* ----------------------------------------------------------- 
	This helper ensures that URL parameters are correctly 
	carried over when advocates are redirected post-action.
	------------------------------------------------------------ */ 
import URI from 'urijs';
import { isEmpty as _isEmpty, } from "lodash";

export default class RedirectHelper {

  redirect(redirectUrl) {
  	window.top.location.href = redirectUrl;
  }

  /**
   * Redirect to the reset cookie url
  */
  redirectToResetCookie(params = {}) {
    window.location.href = this.getResetCookieUrl(params);
  }

  getResetCookieUrl(params = {}) {
    const url = URI(window.location.href.toString()).addSearch('resetcookie', 1);
    if (!_isEmpty(params.trackedAdvocateShortUrlParam)) {
        url.addSearch(params.trackedAdvocateShortUrlParam);
    }
    return url.toString();
  }
}